export const AUCTION_LISTING_QUERY_KEY_PREFIX = '#AuctionListing#';

export const DIRECT_SALE_LISTING_QUERY_KEY_PREFIX = '#DirectSaleListing#';

export const AUCTION_DETAIL_QUERY_KEY_PREFIX = '#ActDetail#';

export const USER_BIDS_QUERY_KEY_PREFIX = '#Bids#';

export const DIRECT_SALE_DETAIL_QUERY_KEY_PREFIX = '#DslDetail#';
